import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import * as types from 'actions/actionTypes';
import rightSidebarDrawers from 'constants/rightSidebarDrawers';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RightSideButtonGroup } from './LayoutStyles';

const RightSideBarButtons = ({ handleRightDrawerToggle }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const visibleComments = !pathname.includes('comments');
  const visibleSummary = !pathname.includes('facilities') && !pathname.includes('partner-files');
  const disabledButton = pathname.includes('new');

  const handleClick = useCallback(
    drawerName => () => {
      handleRightDrawerToggle(drawerName);
      dispatch({ type: types.SIDEBAR_DRAWER_SELECTED, payload: drawerName });
    },
    [dispatch, handleRightDrawerToggle]
  );

  useEffect(() => {
    if (!visibleComments) handleRightDrawerToggle(rightSidebarDrawers.comments, true);
  }, [visibleComments, handleRightDrawerToggle]);

  return (
    <RightSideButtonGroup>
      {visibleComments && (
        <Button color='secondary' variant='contained' onClick={handleClick(rightSidebarDrawers.comments)} disabled={disabledButton}>
          {t('Comments')}
        </Button>
      )}
      {visibleSummary && (
        <Button color='secondary' variant='contained' onClick={handleClick(rightSidebarDrawers.summary)} disabled={disabledButton}>
          {t('Summary')}
        </Button>
      )}
    </RightSideButtonGroup>
  );
};

RightSideBarButtons.propTypes = {
  handleRightDrawerToggle: PropTypes.func.isRequired
};

export default RightSideBarButtons;
